import * as types from "./ActionsOverlayReducer";

export default function userReducer(
    state = {
        overlay: {
            icon: "check",
            show: false,
            text: ""
        }
    }, action) {
    switch (action.type) {
        case types.SHOW_OVERLAY:
            state.overlay = {
                icon: action.icon,
                show: true,
                text: action.text
            };
            break;
        case types.HIDE_OVERLAY:
            state.overlay = state.overlay = {
                icon: action.icon,
                show: false,
                text: ""
            };
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/overlay/OverlayReducer.ts